// Chiffres clés de l'en-tête des pages, au format « head__stats » du thème Rapport
export const ThemeStats = ({ stats }) => (
  <div className="head__stats crm-head-stats" data-testid="page-head-stats">
    {stats.filter(Boolean).map(({ icon: Icon, value, label, badge, tone = "butter", testid }) => (
      <div key={label} className="stat" data-file="" data-testid={testid}>
        <span className="stat__ico"><Icon size={18} /></span>
        <div className="stat__body">
          <div className="stat__value"><span>{typeof value === "number" ? <b data-count={value}>{value.toLocaleString("fr-FR")}</b> : value}</span>{badge && <span className={`badge badge--${tone}`}>{badge}</span>}</div>
          <div className="stat__label">{label}</div>
        </div>
      </div>
    ))}
  </div>
);
